import { Icon, IconProps } from '@chakra-ui/react'

export default function DocumentPaperPenIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        d="M5.99923 14.0026H3.33145C2.59476 14.0026 1.99756 13.4054 1.99756 12.6687V3.33145C1.99756 2.59476 2.59476 1.99756 3.33145 1.99756H11.3348C12.0715 1.99756 12.6687 2.59476 12.6687 3.33145V5.33228"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00049 14.0024L9.75055 13.7863C9.87368 13.7711 9.98821 13.7152 10.076 13.6276L14.3165 9.38715C14.7861 8.91947 14.7879 8.15966 14.3205 7.68977L14.3165 7.68644V7.68644C13.8488 7.21677 13.089 7.21497 12.6191 7.68244V7.68644L8.41733 11.8882C8.33185 11.9731 8.27656 12.0837 8.25993 12.203L8.00049 14.0024Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33098 11.3343V11.3343C4.77847 11.3343 4.33057 10.8864 4.33057 10.3339V10.3339C4.33057 9.7814 4.77847 9.3335 5.33098 9.3335V9.3335C5.8835 9.3335 6.3314 9.7814 6.3314 10.3339V10.3339C6.3314 10.8864 5.8835 11.3343 5.33098 11.3343Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33057 4.66502H9.66612"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33057 6.99949H6.99834"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
